import { useState } from 'react';
import { DonViCoSo, KhachHang, KhoHang, Lo, NhanVien, VatTu, ViTriKho } from '@/types/schemas';

export interface SearchFieldState {
  khachHang: KhachHang | null;
  nhanVien: NhanVien | null;
  vatTu: VatTu | null;
  khoHang: KhoHang | null;
  lo: Lo | null;
  viTri: ViTriKho | null;
  donVi: DonViCoSo | null;
}

export interface SearchFieldActions {
  setKhachHang: (khachHang: KhachHang | null) => void;
  setNhanVien: (nhanVien: NhanVien | null) => void;
  setVatTu: (vatTu: VatTu | null) => void;
  setKhoHang: (khoHang: KhoHang | null) => void;
  setLo: (lo: Lo | null) => void;
  setViTri: (viTri: ViTriKho | null) => void;
  setDonVi: (donVi: DonViCoSo | null) => void;

  // Utility functions
  resetState: () => void;
  updateState: (updates: Partial<SearchFieldState>) => void;
}

export interface UseSearchFieldStateReturn {
  state: SearchFieldState;
  actions: SearchFieldActions;
}

const initialState: SearchFieldState = {
  khachHang: null,
  nhanVien: null,
  vatTu: null,
  khoHang: null,
  lo: null,
  viTri: null,
  donVi: null
};

export function useSearchFieldStates(): UseSearchFieldStateReturn {
  const [state, setState] = useState<SearchFieldState>(initialState);

  const actions: SearchFieldActions = {
    setKhachHang: (khachHang: KhachHang | null) => {
      setState(prev => ({ ...prev, khachHang }));
    },

    setNhanVien: (nhanVien: NhanVien | null) => {
      setState(prev => ({ ...prev, nhanVien }));
    },

    setVatTu: (vatTu: VatTu | null) => {
      setState(prev => ({ ...prev, vatTu }));
    },

    setKhoHang: (khoHang: KhoHang | null) => {
      setState(prev => ({ ...prev, khoHang }));
    },

    setLo: (lo: Lo | null) => {
      setState(prev => ({ ...prev, lo }));
    },

    setViTri: (viTri: ViTriKho | null) => {
      setState(prev => ({ ...prev, viTri }));
    },

    setDonVi: (donVi: DonViCoSo | null) => {
      setState(prev => ({ ...prev, donVi }));
    },

    resetState: () => {
      setState(initialState);
    },

    updateState: (updates: Partial<SearchFieldState>) => {
      setState(prev => ({ ...prev, ...updates }));
    }
  };

  return { state, actions };
}
